import React from "react";
import {Svg, Path, G} from "react-primitives-svg";
import PropTypes from "prop-types";
import {svgSize} from "../helpers/svg";

export default function Icon({fill, height, width, ...rest}) {
  return (
    <Svg
      {...rest}
      {...svgSize(height, width)}
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet">
      <G fill={fill} id="Mobile" fillRule="evenodd">
        <Path
          d="M15.2727273,15.8181818 C14.6705455,15.8181818 14.1818182,16.3069091 14.1818182,16.9090909 L14.1818182,20.7272727 C14.1818182,21.3294545 13.6930909,21.8181818 13.0909091,21.8181818 L3.27272727,21.8181818 C2.67054545,21.8181818 2.18181818,21.3294545 2.18181818,20.7272727 L2.18181818,3.27272727 C2.18181818,2.67054545 2.67054545,2.18181818 3.27272727,2.18181818 L13.0909091,2.18181818 C13.6930909,2.18181818 14.1818182,2.67054545 14.1818182,3.27272727 L14.1818182,7.09090909 C14.1818182,7.69309091 14.6705455,8.18181818 15.2727273,8.18181818 C15.8749091,8.18181818 16.3636364,7.69309091 16.3636364,7.09090909 L16.3636364,3.27272727 C16.3636364,1.46563636 14.898,0 13.0909091,0 L3.27272727,0 C1.46563636,0 0,1.46563636 0,3.27272727 L0,20.7272727 C0,22.5343636 1.46563636,24 3.27272727,24 L13.0909091,24 C14.898,24 16.3636364,22.5343636 16.3636364,20.7272727 L16.3636364,16.9090909 C16.3636364,16.3069091 15.8749091,15.8181818 15.2727273,15.8181818"
          id="Fill-1"
        />
        <Path
          d="M23.6782909,11.2255091 L20.4055636,7.95278182 C19.9795636,7.52623636 19.2879273,7.52623636 18.8619273,7.95278182 C18.4359273,8.37878182 18.4359273,9.06987273 18.8619273,9.49641818 L20.2746545,10.9091455 L8.08374545,10.9091455 C7.48101818,10.9091455 6.99283636,11.3973273 6.99283636,12.0000545 C6.99283636,12.6022364 7.48101818,13.0909636 8.08374545,13.0909636 L20.2773818,13.0909636 L18.8673818,14.5036909 C18.6655636,14.7071455 18.5515636,14.9815091 18.5504727,15.2678727 C18.5477455,15.8706 19.0337455,16.3609636 19.6364727,16.3636909 C19.9250182,16.3626 20.2021091,16.2464182 20.4055636,16.0418727 L23.6782909,12.7691455 C23.6782909,12.7686 23.6788364,12.7686 23.6788364,12.7680545 C24.1048364,12.3420545 24.1042909,11.6509636 23.6782909,11.2255091"
          id="Fill-3"
        />
      </G>
    </Svg>
  );
}

Icon.propTypes = {
  fill: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Icon.displayName = "Icons.Logout";
